import { mergeStyles, mergeStyleSets } from "@fluentui/merge-styles";
import { tokens } from "@fluentui/react-components";
import { FONT_SIZE_REGULAR, FONT_SIZE_SMALL} from "../../../config/fontSizes";

export const openIconClass = mergeStyles({
  position: "absolute",
  bottom: 0,
  right: 0,
  padding: "2px",
  margin: "2px",
  width: "18px",
  height: "18px",
  alignItems: "center",
});

export const subjectClass = mergeStyles({
  paddingTop: "30px",
  paddingBottom: "30px",
  color: tokens.colorNeutralForeground2,
  fontSize: FONT_SIZE_REGULAR,
});


export const scrollableStack = mergeStyles({
  maxHeight: '88vh',
  overflowY: 'auto',
});


export const useStyles = mergeStyleSets({
  commandBar: {
    position: "absolute",
    bottom: "0px",
    right: "0px",
    backgroundColor: tokens.colorNeutralBackground2,
    maxWidth: "40%",
    ":hover": {
      backgroundColor: tokens.colorNeutralBackground2,
    },
    ":hover .childClass": {
      display: "block"
    },
  }
});

export const personaClass = mergeStyles({
  position: "relative",
});

export const personaContainerClass = mergeStyles({
  position: "absolute",
  top: "5px",
  left: "5px",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  maxWidth: "1%",
});

export const conversationClass = mergeStyles({
  padding: "10px",
  position: "relative",
  borderWidth: 0.5,
  borderStyle: "solid",
  borderColor: tokens.colorNeutralStroke2,
  ":hover": {
    backgroundColor: tokens.colorNeutralBackground2Hover,
  },
  ":hover .childClass": {
    display: "block"
  },

  ":hover .childClass2": {
    display: "block"
  }
});

export const childClass = mergeStyles({
  display: "none",
  position: "absolute",
  bottom: "1px",
  left: "1px",
  zIndex: "1"
});

export const childClass2 = mergeStyles({
  display: "none",
  position: "absolute",
  bottom: "1px",
  right: "1px",
  zIndex: "1"
});

export const activityClass = mergeStyles({
  display: "relative",
  position: "absolute",
  top: 0,
  right: 0,
  padding: "5px",
  fontSize: FONT_SIZE_SMALL,
});

export const iconStyles = mergeStyles({
  height: "20px",
  width: "20px",
  padding: "4px",
});

export const emptyStateClass = mergeStyles({
  padding: 32,
  textAlign: "center",
  color: "#888",
});
export const toolTipClass = mergeStyles({
  padding: "3px",
})

export const summayButtonClass = mergeStyles({
  position: "absolute",
  bottom: 0,
  right: 0,
});
